var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.has_store_data
    ? _c(
        "div",
        { staticClass: "fg-container series-details" },
        [
          _c(
            "div",
            { staticClass: "bg-blue" },
            [
              _c("Breadcrumbs", {
                attrs: {
                  currentSeriesObj: _vm.getcurrentSeriesObj(),
                  currentSeries: _vm.selected_series,
                  forceSlice: _vm.forceSlice,
                  sequence: [
                    { type: "base", page: "home" },
                    {
                      type: "module",
                      module: _vm.forceSlice,
                      isforceSlice: true,
                    },
                    { type: "param", param: "series_slug" },
                    { type: "page", page: _vm.tabName },
                  ],
                },
              }),
              _vm._v(" "),
              _vm.isSeriesLoaded
                ? _c("div", { staticClass: "waf-head" }, [
                    _c("div", { staticClass: "sports-name" }, [
                      _c("span", [_vm._v(_vm._s(_vm.seriesSportName))]),
                    ]),
                    _vm._v(" "),
                    _c("h1", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.seriesName) + _vm._s(_vm.pageType)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "series-duration" }, [
                      _vm.seriesDesc
                        ? _c("p", [
                            _c("strong", [_vm._v(_vm._s(_vm.seriesDesc))]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", [
                        _c("span", [_vm._v(_vm._s(_vm.seriesDuration))]),
                        _vm._v(" "),
                        _c("span", { staticClass: "num-matches" }, [
                          _vm._v(_vm._s(_vm.totalMatches) + " matches"),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isSeriesLoaded
            ? _c("div", { staticClass: "dropdown-tab" }, [
                _c("div", { staticClass: "select-wrap" }, [
                  _c(
                    "ul",
                    [
                      _vm._l(_vm.tabsArr, function (t) {
                        return _c(
                          "li",
                          {
                            key: t.id,
                            class: [
                              "no-select",
                              { active: t.id === _vm.selectedTabId },
                              { "btn-disabled": t.isDisabled },
                            ],
                          },
                          [
                            !t.isDisabled && t.tabUrl
                              ? _c("a", { attrs: { href: t.tabUrl } }, [
                                  _c("span", [_vm._v(_vm._s(t.displayName))]),
                                ])
                              : _c("span", [_vm._v(_vm._s(t.displayName))]),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.listingPages && _vm.listingPages.length
                        ? _c(
                            "li",
                            {
                              class: ["submenu", { active: _vm.moreOpened }],
                              on: {
                                click: function ($event) {
                                  return _vm.onMoreToggle()
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "more" }, [
                                _vm._v("More"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "submenu-list" },
                                _vm._l(_vm.listingPages, function (t, t_idx) {
                                  return _c("li", { key: t_idx }, [
                                    t.pageUrl
                                      ? _c(
                                          "a",
                                          { attrs: { href: t.pageUrl } },
                                          [
                                            _c("span", [
                                              _vm._v(_vm._s(t.displayName)),
                                            ]),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(_vm._s(t.displayName)),
                                        ]),
                                  ])
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ])
            : _c("div", { staticClass: "roi-component" }, [_vm._m(0)]),
          _vm._v(" "),
          _vm.isSeriesLoaded &&
          (_vm.selectedTabId == _vm.tabIds.result ||
            _vm.selectedTabId == _vm.tabIds.upcoming)
            ? _c(
                "div",
                {
                  class: [
                    { "match-result match-card-listing": _vm.hasMatchesData },
                    { "no-data": !_vm.hasMatchesData },
                  ],
                },
                [
                  !_vm.hasMatchesData
                    ? _c("p", { staticClass: "msg" }, [
                        _vm._v("\n      No matches available.\n    "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOtherTabHasMatches
                    ? _c("p", { staticClass: "msg" }, [
                        _vm._v(
                          "\n      " +
                            _vm._s(_vm.isOtherTabHasMatches.preText) +
                            "\n      "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "no-data-link",
                            attrs: { href: _vm.isOtherTabHasMatches.linkUrl },
                          },
                          [_vm._v(_vm._s(_vm.isOtherTabHasMatches.linkLabel))]
                        ),
                        _vm._v(
                          "\n      " +
                            _vm._s(_vm.isOtherTabHasMatches.postText) +
                            "\n    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.matchList, function (m, m_idx) {
                    return _c(
                      "article",
                      {
                        key: m_idx,
                        class: [
                          "article-item",
                          "match-card",
                          "item-type-article",
                          { "btn-disabled": m.status == 0 || m.status == -1 },
                        ],
                        attrs: { "data-matchcode": m.match_code },
                      },
                      [
                        m.status == 0 || m.status == -1
                          ? _c("series-fixture", { attrs: { match: m } })
                          : _c(
                              "a",
                              { attrs: { href: _vm.getMatchLink(m) } },
                              [_c("series-fixture", { attrs: { match: m } })],
                              1
                            ),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.tabIds.ptsTable == _vm.selectedTabId
            ? _c("points-table", {
                attrs: {
                  hasPointsTable: _vm.hasPointsTable,
                  tableData: _vm.pointsTable,
                  pageOptionForNoPtsTable: _vm.pageOptionForNoPtsTable,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-data" }, [
      _c("p", { staticClass: "msg" }, [
        _vm._v("No information available for this series."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }